var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmailPrefix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Huge-icon_communication_outline_mail-negative",
    "data-name": "Huge-icon/communication/outline/mail-negative",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 15.5,
    viewBox: "0 0 17.5 15.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M5.2,7.15a.75.75,0,0,0-.9,1.2ZM6.95,9.4,6.5,10h0Zm3.6,0L11,10h0ZM13.2,8.35a.75.75,0,0,0-.9-1.2ZM3.75,3.5h10V2h-10ZM16,5.75v8h1.5v-8ZM13.75,16h-10v1.5h10ZM1.5,13.75v-8H0v8ZM3.75,16A2.25,2.25,0,0,1,1.5,13.75H0A3.75,3.75,0,0,0,3.75,17.5ZM16,13.75A2.25,2.25,0,0,1,13.75,16v1.5a3.75,3.75,0,0,0,3.75-3.75ZM13.75,3.5A2.25,2.25,0,0,1,16,5.75h1.5A3.75,3.75,0,0,0,13.75,2ZM3.75,2A3.75,3.75,0,0,0,0,5.75H1.5A2.25,2.25,0,0,1,3.75,3.5ZM4.3,8.35,6.5,10l.9-1.2L5.2,7.15ZM11,10l2.2-1.65-.9-1.2L10.1,8.8ZM6.5,10A3.75,3.75,0,0,0,11,10l-.9-1.2a2.25,2.25,0,0,1-2.7,0Z",
    transform: "translate(0 -2)",
    fill: "#656a72"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailPrefix);
export default __webpack_public_path__ + "static/media/email-prefix.13d89b19995ab1f9cfa778603db18505.svg";
export { ForwardRef as ReactComponent };